import React from "react";
import ReactDOM from "react-dom";
import styles from "../styles/loadingModal.module.css";

const LoadingModal = ({ message, detail, step, stepTotal, isVisible }) => {
  if (!isVisible) return null;

  const hasProgress = stepTotal > 0 && step > 0;
  const progressPct = hasProgress ? Math.min(100, Math.round((step / stepTotal) * 100)) : null;

  return ReactDOM.createPortal(
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.spinner}>
          <div className={styles.spinnerCircle}></div>
        </div>
        <p className={styles.message}>{message}</p>
        {detail ? <p className={styles.detail}>{detail}</p> : null}
        {hasProgress ? (
          <div className={styles.progressWrap}>
            <div className={styles.progressMeta}>
              <span>{step} / {stepTotal}</span>
              <span>{progressPct}%</span>
            </div>
            <div className={styles.progressTrack}>
              <div className={styles.progressBar} style={{ width: `${progressPct}%` }} />
            </div>
          </div>
        ) : null}
      </div>
    </div>,
    document.body
  );
};

export default LoadingModal;
